import { render, staticRenderFns } from "./TabAddition.vue?vue&type=template&id=55389060&"
import script from "./TabAddition.vue?vue&type=script&lang=js&"
export * from "./TabAddition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports